import { render, staticRenderFns } from "./GftSwiperSlide.vue?vue&type=template&id=adbb402e"
import script from "./GftSwiperSlide.vue?vue&type=script&lang=ts"
export * from "./GftSwiperSlide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports